export const state = () => ({
	company: {},
	ttl_company: null,
	cache_duration_company: 3600000, // 1 heure
})

function isInCacheCompany(state, companyId) {
	if (state.cache_key_company !== buildCacheKeyCompany(companyId)) {
		return false
	}
	if (state.ttl_company === null || state.ttl_company < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyCompany(companyId) {
	return `company:${companyId}`
}
export const actions = {
	// TODO: To refacto to use partialUpdate main method
	async partialUpdateBranding({ commit, state }, { data }) {
		return await useNuxtApp()
			.$api(`/api/companies/${state.company.id}/`, { method: 'PUT', body: data })
			.then((res) => {
				commit('setCompany', { data: res, companyId: state.company.id })
				return res
			})
	},

	async delete(_, { companyId }) {
		return await useNuxtApp()
			.$api(`/api/companies/${companyId}/`, { method: 'DELETE' })
			.then((res) => {
				return res
			})
	},

	async retrieve({ state, commit }, { companyId, force = false }) {
		if (isInCacheCompany(state, companyId) && !force) {
			return state.company
		}
		return await useNuxtApp()
			.$api(`/api/companies/${companyId}/`)
			.then((res) => {
				commit('setCompany', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCacheCompany')
				throw err
			})
	},

	async create(_, { data }) {
		return await useNuxtApp()
			.$api(`/api/company/`, { method: 'POST', body: data })
			.then((res) => {
				return res
			})
	},

	async partialUpdate({ commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/`, { method: 'PATCH', body: data })
			.then((res) => {
				commit('invalidateCacheCompany')
				commit('setCompany', { data: res, companyId })
				return res
			})
	},

	async sendConfirmationEmail(_, { data }) {
		return await useNuxtApp()
			.$api(`/api/company/send-confirmation-email/`, { method: 'POST', body: data })
			.then((res) => {
				return res
			})
	},
	async checkTokenAndAuth({ commit }, { data }) {
		return await useNuxtApp()
			.$api(`/api/company/check-confirmation-token/`, { method: 'POST', body: data })
			.then((res) => {
				useCookie('auth', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/app/',
				}).value = res
				useCookie('token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.token
				useCookie('refresh_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.refresh_token
				useCookie('access_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.access_token
				commit('setAuth', res, { root: true })
			})
	},
}

export const mutations = {
	setCompany(state, { data, companyId }) {
		state.company = {
			...(state.company || {}),
			...data,
		}
		state.ttl_company = Date.now() + state.cache_duration_company
		state.cache_key_company = buildCacheKeyCompany(companyId)
	},

	clearCacheCompany(state) {
		state.company = {}
		state.ttl_company = null
		state.cache_key_company = ''
	},

	invalidateCacheCompany(state) {
		state.ttl_company = null
	},
}
